import { DateTime } from "luxon";

import { pluraliseUnit } from "/imports/libs/format";

/**
 * Why a date can't join a pack measured from its first session. Clients pick
 * their first lesson and build forward from it, so the limit they meet is the
 * far end — said as the real date, not as a bare "4 months".
 *
 * `deadline` is the same end-of-validity the caller blocks the tap with, so the
 * date quoted is always the date enforced.
 */
export function packWindowMessage({ firstISO, deadline, dur, unit, noun = "session" }) {
  // Booking dates are fake UTC (club wall clock labeled Z).
  const first = DateTime.fromISO(firstISO, { zone: "utc" });
  return `Your pack runs ${dur} ${pluraliseUnit(dur, unit)} from your first ${noun} on ${first.toFormat("ccc d LLL")} — you can add dates up to ${deadline.toFormat("ccc d LLL")}.`;
}
